<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="1" rx="0" ry="0" width="345" height="33" />
        <rect x="16" y="50" rx="0" ry="0" width="345" height="80" />
        <rect x="15" y="150" rx="0" ry="0" width="345" height="60" />
        <rect x="16" y="230" rx="0" ry="0" width="57" height="57" />
        <rect x="110" y="230" rx="0" ry="0" width="57" height="57" />
        <rect x="207" y="230" rx="0" ry="0" width="57" height="57" />
        <rect x="300" y="230" rx="0" ry="0" width="57" height="57" />
        <rect x="13" y="300" rx="0" ry="0" width="102" height="81" />
        <rect x="135" y="300" rx="0" ry="0" width="102" height="81" />
        <rect x="260" y="300" rx="0" ry="0" width="102" height="81" />
        <rect x="13" y="375" rx="0" ry="0" width="345" height="81" />
        <rect x="14" y="468" rx="0" ry="0" width="122" height="81" />
        <rect x="153" y="499" rx="0" ry="0" width="83" height="16" />
        <rect x="153" y="470" rx="0" ry="0" width="200" height="16" />
        <rect x="153" y="536" rx="0" ry="0" width="83" height="11" />
        <rect x="16" y="572" rx="0" ry="0" width="122" height="81" />
        <rect x="155" y="603" rx="0" ry="0" width="83" height="16" />
        <rect x="155" y="574" rx="0" ry="0" width="200" height="16" />
        <rect x="155" y="640" rx="0" ry="0" width="83" height="11" />
    </content-loader>
</template>

<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader },
        data: () => ({
            loading: true
        }),
    }
</script>



// WEBPACK FOOTER //
// src/skeleton/publicSkeleton.vue